import {lazy} from 'react';

const CookiePolicy = lazy(() => import('./CookiePolicy'));

export default CookiePolicy;
